import { Component } from './../../router/types';
import baseService from '@/utils/http/axios'
import ls from '@/utils/Storage';
import { BasicLayout, RouteView } from '@/layouts'
import { resetRouter } from '@/router'
import { asyncRouterMap } from '@/config/router.config'
import { isMobile } from '@/utils/device'
import { message } from 'ant-design-vue'
import { clearUserInfo } from '@/utils/util'

/**
 * 向后端请求用户的菜单，动态生成路由
 */

const permission = {
    state: {
        addRouters: [],//路由和菜单
        addActions: [],//按钮权限
        addRoles: []//角色
    },
    mutations: {
        SET_ROUTERS: (state, routers) => {
            state.addRouters = routers
        },
        SET_ACTIONS: (state, actions) => {
            state.addActions = actions
        },
        SET_ROLES: (state, roles) => {
            state.addRoles = roles
        }
    },
    actions: {
        GenerateRoutes({ commit }, router) {
            if (!ls.get('ACCESS_TOKEN')) {
                resetRouter(router)
                router.push('/user/login')
                return Promise.reject('没有登录凭证')
            }

            return new Promise((resolve, reject) => {
                // 添加超时控制
                let isResolved = false
                const timeoutId = setTimeout(() => {
                    if (!isResolved) {
                        console.error('权限请求超时')
                        resetRouter(router)
                        commit('SET_ROUTERS', [])
                        ls.remove('PERMISSION')
                        ls.remove('USER_routers')
                        message.error('权限请求超时，请重新登录')
                        clearUserInfo()
                        router.push('/user/login')
                        reject(new Error('请求超时'))
                    }
                }, 15000) // 15秒超时

                let requeryParam = {
                    url: '/admin/v1/userPermission',
                    method: 'get',
                    timeout: 12000 // axios 超时
                }

                baseService(requeryParam).then((res: any) => {
                    isResolved = true
                    clearTimeout(timeoutId)
                    resetRouter(router)

                    if (res.code == 200) {
                        // 1转换权限和菜单的变量
                        let routers = res.data.routers
                        routers.component = BasicLayout
                        if (isMobile.value) {
                            //如果是手机端
                            routers.redirect = '/kezhangClient'
                        }
                        routers.children.forEach((item: any) => {
                            if (item.component == 'RouteView') {
                                item.component = RouteView
                                item.children.forEach((son: any) => {
                                    if (son.component == 'RouteView') {
                                        son.component = RouteView
                                        son.children.forEach((grandSon: any) => {
                                            grandSon.component = asyncRouterMap[grandSon.name] || null
                                        })
                                    } else {
                                        son.component = asyncRouterMap[son.name] || null
                                    }
                                })
                            } else {
                                item.component = asyncRouterMap[item.name] || null
                            }
                        })

                        commit('SET_ROUTERS', routers.children)
                        router.addRoute(routers)
                        // 2可以将按钮权限存入localStorage
                        commit('SET_ACTIONS', res.data.actions)
                        commit('SET_ROLES', res.data.roles)

                        // ⚠️ 关键：将权限数据保存到 localStorage
                        // 保存路由数据作为权限标识
                        ls.set('PERMISSION', routers.children)
                        ls.set('USER_routers', routers)

                        console.log('权限数据已保存到 localStorage')
                        resolve(routers)
                    } else {
                        // 权限请求失败
                        commit('SET_ROUTERS', [])
                        ls.remove('PERMISSION')
                        ls.remove('USER_routers')
                        message.error(res.msg || '获取权限失败，请重新登录')
                        clearUserInfo()
                        router.push('/user/login')
                        reject(res.msg)
                    }
                }).catch(error => {
                    isResolved = true
                    clearTimeout(timeoutId)
                    resetRouter(router)
                    commit('SET_ROUTERS', [])
                    ls.remove('PERMISSION')
                    ls.remove('USER_routers')
                    console.error('权限请求失败:', error)
                    message.error('获取权限失败，请重新登录')
                    clearUserInfo()
                    router.push('/user/login')
                    reject(error)
                })
            })
        }
    }
}

export default permission
